import {
    TopicState,
    hashtagsAndQueryKey,
    initialPostsState,
    initialTopicState,
} from "@/mk2/apps/forum/containers/Topic/Topic.reducers";
import { Count } from "@/mk2/components/NotificationsBadge";
import { FeedItemOrGroup } from "@/mk2/containers/PageHeader/PageHeader.reducers";
import { memoizeOne } from "@/mk2/helpers/cache";
import { AppState, getPageHeaderState } from "@/mk2/reducers";

export const getTopicState = (state: AppState, slug: string): TopicState => {
    if (!state.containers.forum.forumTopic[slug]) {
        return initialTopicState;
    }

    return state.containers.forum.forumTopic[slug];
};

export const getTopicPostsState = (
    state: AppState,
    slug: string,
    hashtags: string[],
    query: string,
) => {
    const topicState = getTopicState(state, slug);

    const hashtagsStr = hashtags.length ? hashtags.join(",") : "";
    const key = hashtagsAndQueryKey(hashtagsStr, query);
    if (!topicState.posts[key]) {
        return initialPostsState;
    }

    return topicState.posts[key];
};

const getTopicLastVisitedCountCached = memoizeOne(
    (feedMenu: FeedItemOrGroup[], topicId: number): Count => {
        const topicItemName = `topic-${topicId}`;

        const topicItem = feedMenu.reduce((acc, rootItem) =>
            rootItem.isGroup
                ? rootItem.items.reduce(
                      (acc2, item) => (item.name === topicItemName ? item : acc2),
                      acc,
                  )
                : rootItem.name === topicItemName
                  ? rootItem
                  : acc,
        );

        return topicItem ? topicItem.lastVisitCount : null;
    },
);

export const getTopicLastVisitedCount = (state: AppState, topicId: number) =>
    getTopicLastVisitedCountCached(getPageHeaderState(state).feedMenu, topicId);
